import axios from "axios";
import { ENDPOINT } from "../services/apiUrls";
import { ToastNotifyError } from "./toast-helper";
import { prepareDimensions } from "./ga-helpers";

export async function captureInterest(dataToSend = {}) {
  const url = process.env.REACT_APP_DOTPE_API_URL + ENDPOINT.DOTPE.enquiry;
  if (!url) return;
  const body = {
    "name": "Rista Support",
    "phone": "8447902064",
    "email": "rista.support@dotpe.in",
    "source": window.location.href
  }
  const dimensionData = prepareDimensions();
  try {
    const response = await axios.post(url, body);
    const data: { id?: number; message?: string; status: boolean; } = response.data;
    if (!data.status) { ToastNotifyError('Something went wrong'); return false; }
    const enquiryApiResponse = await axios.patch(url + '/' + data.id, { extraInfo: { ...dimensionData, ...dataToSend } });
    const enquiryResponse: { message?: string; status: boolean; } = enquiryApiResponse.data;
    return enquiryResponse.status;
  }
  catch (e) {
    ToastNotifyError('something went wrong');
    return false;
  }
}